import schema from '../schemas/incident';
import { migrateTimestampsFromLegacyUpdatedAt } from '../timestamps';

export default {
  incidents: {
    schema,
    migrationStrategies: {
      // Made incident involved vessel description optional
      1: doc => doc,
      2: migrateTimestampsFromLegacyUpdatedAt
    }
  }
};
